<script setup>

import {checkDataElement} from '../../apps/base'


const model = defineModel();
const props = defineProps({
    options: Array,
    dataElement: String,
    optionClass: [Object, Array, String],
});
const name = 'radio_' + Math.round(Math.random() * 1e6);

</script>

<template>
    <div>
        <div :class="optionClass" :key="name + '_' + key" v-for="(option, key) in options">
            <input
                    :data-element="checkDataElement(dataElement + '_field_' + key)"
                    type="radio"
                    :name="name"
                    :id="name + '_' + key"
                    :disabled="option.disabled"
                    v-model="model"
                    :checked="option.value === model"
            />
            <label :data-element="checkDataElement(dataElement + '_label_' + key)" :for="name + '_' + key">{{ option.title }}</label>
        </div>
    </div>
</template>

<script>
/* global Mango */
export default {
    name: "FieldRadioGroup",
}
</script>

<style scoped>

</style>